"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GodModeTable = void 0;
var _dataGrid = require("@ori-ui/data-grid");
var _license = require("@ori-ui/license");
var _mui = require("@ori-ui/mui");
var _shoppingContext = require("@ori/shopping-context");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _models = require("../../models");
var _TableToolbar = require("./components/TableToolbar");
var _jsxRuntime = require("react/jsx-runtime");
(0, _license.applyLicense)();
const DataGrid = (0, _mui.styled)(_dataGrid.DataGridPro)(({
  theme
}) => ({
  '.row-qualified': {
    background: theme.palette.primary.light
  },
  '.cell-clickable': {
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline'
    }
  }
}));
const idExtractor = row => row.ruleId;
const getOpenUrl = ruleId => `/backoffice/RuleDetail/Edit?ruleId=${ruleId}`;
const onCellClick = ({
  colDef,
  value
}) => {
  if (colDef.field !== 'ruleId') {
    return;
  }
  window.open(getOpenUrl(value), '_blank');
};
const getRowClassName = params => {
  const row = params.row;
  return row.conditionQualificationCount > 0 ? 'row-qualified' : '';
};
const components = {
  toolbar: _TableToolbar.TableToolbar
};
const rowFilter = filter => row => {
  switch (filter) {
    case _models.GodModeRowFiltering.all:
      return true;
    case _models.GodModeRowFiltering.qualified:
      return row.conditionQualificationCount > 0;
    case _models.GodModeRowFiltering.used:
      return row.actionUsedQualificationCount > 0;
    case _models.GodModeRowFiltering.error:
      return row.hasException;
    default:
      return false;
  }
};
const GodModeTable = exports.GodModeTable = /*#__PURE__*/(0, _react.memo)(() => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    columns,
    onWidthChanged,
    onColumnOrderChange
  } = (0, _hooks.useGodModeColumns)();
  const {
    shoppingContext
  } = (0, _shoppingContext.useShoppingContext)();
  const [density, setDensity] = (0, _hooks.useStoredState)(_models.LocalStorageKey.Density, 'compact');
  const [columnVisibilityModel, setColumnVisibilityModel] = (0, _hooks.useStoredState)(_models.LocalStorageKey.ColumnVisibility, undefined);
  const onStateChanged = (0, _react.useCallback)(e => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- third party component
    setDensity(e.density.value);
  }, [setDensity]);
  const toSort = shoppingContext?.godModeOutput?.outputItems;
  const [filter, setFilter] = (0, _react.useState)(_models.GodModeRowFiltering.all);
  const provider = (0, _react.useMemo)(() => {
    const usedFilter = rowFilter(filter);
    const allData = toSort ?? [];
    const data = allData.filter(usedFilter);
    return {
      data,
      filter,
      setFilter,
      filterCounts: {
        [_models.GodModeRowFiltering.all]: allData.length,
        [_models.GodModeRowFiltering.qualified]: allData.filter(x => x.conditionQualificationCount > 0).length,
        [_models.GodModeRowFiltering.used]: allData.filter(x => x.actionUsedQualificationCount > 0).length,
        [_models.GodModeRowFiltering.error]: allData.filter(x => x.hasException).length
      }
    };
  }, [toSort, filter, setFilter]);
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  const locales = (0, _react.useMemo)(() => ({
    columnMenuFilter: formatMessage(_models.TranslationKey.columnMenuFilter),
    columnMenuHideColumn: formatMessage(_models.TranslationKey.columnMenuHideColumn),
    columnMenuLabel: formatMessage(_models.TranslationKey.columnMenuLabel),
    columnMenuManageColumns: formatMessage(_models.TranslationKey.columnMenuManageColumns),
    columnMenuShowColumns: formatMessage(_models.TranslationKey.columnMenuShowColumns),
    columnMenuSortAsc: formatMessage(_models.TranslationKey.columnMenuSortAsc),
    columnMenuSortDesc: formatMessage(_models.TranslationKey.columnMenuSortDesc),
    columnMenuUnsort: formatMessage(_models.TranslationKey.columnMenuUnsort),
    columnsPanelDragIconLabel: formatMessage(_models.TranslationKey.columnsPanelDragIconLabel),
    columnsPanelHideAllButton: formatMessage(_models.TranslationKey.columnsPanelHideAllButton),
    columnsPanelShowAllButton: formatMessage(_models.TranslationKey.columnsPanelShowAllButton),
    columnsPanelTextFieldLabel: formatMessage(_models.TranslationKey.columnsPanelTextFieldLabel),
    columnsPanelTextFieldPlaceholder: formatMessage(_models.TranslationKey.columnsPanelTextFieldPlaceholder),
    filterOperatorAfter: formatMessage(_models.TranslationKey.filterOperatorAfter),
    filterOperatorBefore: formatMessage(_models.TranslationKey.filterOperatorBefore),
    filterOperatorContains: formatMessage(_models.TranslationKey.filterOperatorContains),
    filterOperatorEndsWith: formatMessage(_models.TranslationKey.filterOperatorEndsWith),
    filterOperatorEquals: formatMessage(_models.TranslationKey.filterOperatorEquals),
    filterOperatorIs: formatMessage(_models.TranslationKey.filterOperatorIs),
    filterOperatorIsAnyOf: formatMessage(_models.TranslationKey.filterOperatorIsAnyOf),
    filterOperatorIsEmpty: formatMessage(_models.TranslationKey.filterOperatorIsEmpty),
    filterOperatorIsNotEmpty: formatMessage(_models.TranslationKey.filterOperatorIsNotEmpty),
    filterOperatorNot: formatMessage(_models.TranslationKey.filterOperatorNot),
    filterOperatorOnOrAfter: formatMessage(_models.TranslationKey.filterOperatorOnOrAfter),
    filterOperatorOnOrBefore: formatMessage(_models.TranslationKey.filterOperatorOnOrBefore),
    filterOperatorStartsWith: formatMessage(_models.TranslationKey.filterOperatorStartsWith),
    filterPanelAddFilter: formatMessage(_models.TranslationKey.filterPanelAddFilter),
    filterPanelColumns: formatMessage(_models.TranslationKey.filterPanelColumns),
    filterPanelDeleteIconLabel: formatMessage(_models.TranslationKey.filterPanelDeleteIconLabel),
    filterPanelInputLabel: formatMessage(_models.TranslationKey.filterPanelInputLabel),
    filterPanelInputPlaceholder: formatMessage(_models.TranslationKey.filterPanelInputPlaceholder),
    filterPanelLogicOperator: formatMessage(_models.TranslationKey.filterPanelLogicOperator),
    filterPanelOperator: formatMessage(_models.TranslationKey.filterPanelOperator),
    filterPanelOperatorAnd: formatMessage(_models.TranslationKey.filterPanelOperatorAnd),
    filterPanelOperatorOr: formatMessage(_models.TranslationKey.filterPanelOperatorOr),
    filterPanelRemoveAll: formatMessage(_models.TranslationKey.filterPanelRemoveAll),
    noResultsOverlayLabel: formatMessage(_models.TranslationKey.noRulesAvailable),
    noRowsLabel: formatMessage(_models.TranslationKey.noData),
    toolbarColumns: formatMessage(_models.TranslationKey.toolbarColumns),
    toolbarColumnsLabel: formatMessage(_models.TranslationKey.toolbarSelectColumns),
    toolbarDensity: formatMessage(_models.TranslationKey.toolbarDensity),
    toolbarDensityComfortable: formatMessage(_models.TranslationKey.toolbarDensityComfortable),
    toolbarDensityCompact: formatMessage(_models.TranslationKey.toolbarDensityCompact),
    toolbarDensityLabel: formatMessage(_models.TranslationKey.toolbarDensity),
    toolbarDensityStandard: formatMessage(_models.TranslationKey.toolbarDensityStandard),
    toolbarExport: formatMessage(_models.TranslationKey.toolbarExport),
    toolbarExportCSV: formatMessage(_models.TranslationKey.toolbarExportCSV),
    toolbarExportExcel: formatMessage(_models.TranslationKey.toolbarExportExcel),
    toolbarExportLabel: formatMessage(_models.TranslationKey.toolbarExport),
    toolbarExportPrint: formatMessage(_models.TranslationKey.toolbarExportPrint),
    toolbarFilters: formatMessage(_models.TranslationKey.toolbarFilters),
    toolbarFiltersLabel: formatMessage(_models.TranslationKey.toolbarShowFilters),
    toolbarFiltersTooltipActive: value => value > 1 ? formatMessage(_models.TranslationKey.toolbarFiltersTooltipActiveXValue, {
      value
    }) : formatMessage(_models.TranslationKey.toolbarFiltersTooltipActiveOne),
    toolbarFiltersTooltipHide: formatMessage(_models.TranslationKey.toolbarFiltersTooltipHide),
    toolbarFiltersTooltipShow: formatMessage(_models.TranslationKey.toolbarFiltersTooltipShow)
  }), [formatMessage]);
  if (!shoppingContext?.godModeOutput) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_contexts.CheckoutGodModeProvider, {
    value: provider,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      "data-testid": getTestId('columns-order'),
      "data-testid-content": JSON.stringify(columns.map(x => x.field))
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(DataGrid, {
      disableRowSelectionOnClick: true,
      columns: columns,
      rows: provider.data,
      columnVisibilityModel: columnVisibilityModel,
      density: density,
      slots: components,
      getRowId: idExtractor,
      getRowClassName: getRowClassName,
      localeText: locales,
      onCellClick: onCellClick,
      onColumnWidthChange: onWidthChanged,
      onColumnVisibilityModelChange: setColumnVisibilityModel,
      onColumnOrderChange: onColumnOrderChange,
      onStateChange: onStateChanged
    })]
  });
});